import Rule from "./rule";

/**
 * Rule to check if certain products have certain tags
 */
class ProductTagsRule extends Rule {
  type = "product.tags";
  dependencies = {
    evaluate: ["executeGQL"],
    hydrateMeta: ["idToGraphQlId", "executeGQL"]
  }

  constructor(config = {}) {
    super(config);
    this.initialize();
  }

  async evaluate(data) {
    super.evaluate(data);
    
    this.log = [];
    console.groupCollapsed(this.logPrefix);
    let pass = true;

    // This doesn't work if product is set to seo_hidden :(((
    // let ids = this.config.tags.map(tagCondition => tagCondition.id);
    // let results = await Stencil.Utilities.getProductJson(ids);

    let ids =  this.config.tags.map(obj => `id:${obj.id}`).join(' OR ');
    let results = await Stencil.Helpers.executeGQL(`
      query getProducts($first: Int, $query: String) {
        products(first: $first, query: $query) {
          edges {
            node {
              id
              tags
            }
          }
        }
      }`, { variables: { first: 50, query: ids }});

    console.log('GQL Variables', { first: 50, query: ids });
    console.log('GQL Result', results);

    this.config.tags.forEach(tagCondition => {
      let applicableEdge = results.data.products.edges.find(edge => edge.node.id.split("/").pop() == tagCondition.id);
      let tags = applicableEdge?.node.tags || [];
      pass &&= tags.includes(tagCondition.value);
      
      console.log('Pass?', pass);
      this.addLog(pass, tagCondition.value, tags.join(", "), "includes");
    });

    console.groupEnd();
    return pass;
  }

  explain() {
    return this.config.tags.map(tagCondition => 
      `${Stencil.Logger.product({ title: this.meta[tagCondition.id]?.title, id: tagCondition.id })} has ${Stencil.Logger.tag(tagCondition.value)}`).join(" and ");
  }

  async hydrateMeta() {
    super.hydrateMeta();

    const graphQlIds = (this.config.tags || [])
      .map(tagCondition => Stencil.Helpers.idToGraphQlId(tagCondition.id, "product"));
  
    const result = await Stencil.Helpers.executeGQL(`{
      nodes(ids: ${JSON.stringify(graphQlIds)}) {
        ... on Product {
          id
          title
        }
      }
    }`, {});
    
    result.data.nodes.forEach(node => {
      this.meta[node.id.split("/").pop()] = node;
    });
  }
}

export default ProductTagsRule;